import Text from '@redbubble/design-system/src/Text';
import React, { FC } from 'react';

import styles from '../../Coupon.module.scss';

interface CouponAppliedMessageProps {
  successMessage: string;
  errorMessage: string;
}

export const CouponAppliedMessage: FC<CouponAppliedMessageProps> = ({
  successMessage,
  errorMessage,
}) => {
  return (
    <span
      className={errorMessage ? styles.couponApplyError : styles.couponApplied}
      data-testid="coupon-message"
      id="coupon-code-apply-message"
    >
      <Text
        type="body2"
        intent={errorMessage ? 'error' : 'success'}
        aria-live="polite"
      >
        {errorMessage || successMessage}
      </Text>
    </span>
  );
};
